
//import "./components/datepicker.js";
//import { InputGuests } from "./components/InputGuests";
import functions from "./functions";

import lozad from 'lozad';

$(function () {

  let scrollFromUrl = (new URLSearchParams(location.search)).get('scroll');
  if ( scrollFromUrl ) {
    setTimeout(() => {
      functions.scrollToElement('#'+scrollFromUrl, 100);
    }, 300);
  }

  /*$('.input-guests').each((i, elem) => {
    elem._inputGuests = new InputGuests(elem);
  });*/

  $(document).on('click', '[data-scroll-to]', e => {
    e.preventDefault();
    const $this = $(e.target);
    let scrollTo = $this.attr('data-scroll-to').split(',');
    functions.scrollToElement(scrollTo[0], scrollTo[1] || 0);
  });

  $(document).on('click', 'button[href]', e => {
    e.preventDefault();
    location = e.currentTarget.getAttribute('href');
  });

  (() => {
    const $header = $('.main-header');
    const $collapser = $header.find('.navbar-collapse');
    $collapser
        .on('show.bs.collapse', () => {
            $header.addClass('navbar-transition navbar-shown');
        })
        .on('hide.bs.collapse', () => {
            $header.removeClass('navbar-shown');
        })
        .on('hidden.bs.collapse', () => {
            $header.removeClass('navbar-transition');
        });
  })();

  // menu links active
  const path = location.pathname.replace(/\/$/, '');
  $('.main-header [href], footer [href]').each((i, link) => {
      let href = link.getAttribute('href');
      if ( href && href != '#' ) {
          var hash = href.split('#')[1];
          href = href.split('#')[0];
          href = href.split('?')[0].replace(/\/$/, '').replace('https://perla', '');
          if ( path === href ) {
              if ( !hash ) {
                $(link).addClass('active').closest('.nav-item').addClass('active');
              }
              else if ( hash && ('#'+hash) == this.location.hash ) {
                $(link).closest('.nav-item').addClass('active');
              }
          }
      }
  });

  const $wpGallerys = $('.wp-block-gallery:not(.collage-gallery)');
  $wpGallerys.each((index, wpGallery) => {
    let $wpGallery = $(wpGallery);
    const $wpGalleryLinks = $wpGallery.find('.wp-block-image');
    const wpGalleryArray = $wpGalleryLinks.map((i, elem) =>
    {
        const $elem = $(elem);
        const $img = $elem.find('img');
        const src = $img.attr('data-src');

        let imgs = $img.attr('data-srcset').split(', ');
        let sizes = $.map(imgs, img => {
            let size = img.match(/(\d+)w$/);
            return size ? +size[1] : 9999;
        });
        let minSize = sizes.indexOf(Math.min.apply(Math, sizes));
        minSize = minSize > -1 ? minSize : 0;
        let thumb = imgs[minSize].replace(/ \d+w$/, '');
        return {
            src: src,
            thumb: thumb || src
        };
    });

    $wpGallery.on('click', '.wp-block-image', e =>
    {
        e.preventDefault();
        let index = $wpGalleryLinks.index(e.currentTarget);

        if ($(e).hasClass('lg-on'))
        {
            $(e).data('lightGallery').index = index;
            $(e).data('lightGallery').build(index);
        } else
        {
            $(e).lightGallery({
                dynamic: true,
                thumbnail: true,
                toogleThumb: false,
                thumbWidth: 130,
                thumbMargin: 10,
                download: false,
                autoplay: false,
                preload: 2,
                index: index,
                dynamicEl: wpGalleryArray
            }).addClass('lg-on');
        }
    });

    $wpGallery.each((i, elem) =>
    {
        const $links = $(elem).find('.wp-block-image');
        let eq = $links.length - 1;
        $links.eq(eq).append(`
          <div class="see-all-images position-absolute bottom-0 end-0 pe-3 pb-3">
            <div class="btn btn-light" data-gallery-id="gallery-section" data-index="0">
              Gallery (${wpGalleryArray.length})
            </div>
          </div>
        `);
    });
  });
});

$(window).on('load', () => {

  const header = $('.main-header')[0];
  if (!header) return;
  let scrolled = false;

  const checkHeader = () => {
      if ( window.scrollY > 0 ) {
          header.classList.add('active');
      } else {
          header.classList.remove('active');
      }
  }
  let timer = 0;
  $(window).on('scroll', () => {
      if ( !scrolled ) { // annoying first scroll when page load already scrolled
          scrolled = true;
          return;
      } else {
          clearTimeout(timer);
          timer = setTimeout(checkHeader, 25);
      }
  });
  checkHeader();
});